import { render, staticRenderFns } from "./cashback.vue?vue&type=template&id=4e9d608e"
import script from "./cashback.vue?vue&type=script&lang=js"
export * from "./cashback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/branches/branch/bonuses/cashback.vue
// module id = 5NiP
// module chunks = 0